// src/app/pipes/format-time-range.pipe.ts

import { inject, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

interface TimeRangeResult {
  range: string;
  timeZone: string;
}

@Pipe({
  name: 'formatTimeRange',
  standalone: true,
})
export class FormatTimeRangePipe implements PipeTransform {

  private datePipe = inject(DatePipe);
  transform(startDate: Date | string, endDate: Date | string): TimeRangeResult {

    // Format the start time (e.g., "1:00")
    const startTime = this.datePipe.transform(startDate, 'h:mm');

    // Format the end time with am/pm (e.g., "2:00AM")
    const endTime = this.datePipe.transform(endDate, 'h:mm a');

    // Check for valid start and end times
    if (!startTime || !endTime) {
      return { range: '', timeZone: '' };
    }

    const start = new Date(startDate);

    // Get the Time Zone Abbreviation using Intl API
    const parts = new Intl.DateTimeFormat(undefined, {
      timeZoneName: 'short',
    }).formatToParts(start);
    
    const timeZone = parts.find(part => part.type === 'timeZoneName')?.value ?? '';

    return {
      range: `${startTime} - ${endTime}`,
      timeZone: timeZone,
    };
  }
}